export type TimeGreeting = "Bom dia" | "Boa tarde" | "Boa noite";

export function getTimeGreeting(date: Date = new Date()): TimeGreeting {
  const hour = date.getHours();
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

export function firstName(name: string): string {
  return name.trim().split(/\s+/).filter(Boolean)[0] ?? "";
}
